import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  public file: Blob;

  constructor() {}

  setFile(fileAsByteArray) : Promise<any> {
    return new Promise((resolve, reject) => {
      var bytes = new Uint8Array(fileAsByteArray);

      this.file = new Blob([bytes], {type: 'application/pdf'});
      resolve(this.file);
    });
  }

  downloadFile(fileName) : void {
    FileSaver.saveAs(this.file, fileName);
  }

}
